import React from "react";
import COR from "../../PicesForPages/CashOutRefinance.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function CashOutRefinance() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent CashOutRefinancePageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="background-video CORImage"
        />
        <div className="purchasetopBox CashOutRefinancePageTopBox">
          {/* The existing Purchase span */}
          <span>Cash Out Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span
              className="purchaseBottomLeftContent"
              style={{ color: "red" }}
            >
              Please note that refinancing your existing loan could lead to
              higher total finance charges over the life of the new loan.
            </span>
            <span className="purchaseBottomLeftContent">
              Please note that refinancing your existing loan could lead to
              higher total finance charges over the life of the new loan.
            </span>

            <span className="purchaseBottomLeftHeader">
              What are the benefits?
            </span>
            <span className="purchaseBottomLeftContent">
              By leveraging your home’s equity, you can access funds to pay off
              debts or handle upcoming expenses. Refinancing could also help you
              secure a lower interest rate, which may reduce your monthly
              mortgage payments. Additionally, it is tax-deductible.
            </span>

            <span className="purchaseBottomLeftHeader">How can we help?</span>
            <span className="purchaseBottomLeftContent">
              If you are considering this type of refinancing, Prime Home
              Mortgage, INC is here to assist you in finding a suitable program.
              We provide cash-out options for both owner-occupied and
              non-owner-occupied properties, offering competitive and affordable
              rates.
            </span>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default CashOutRefinance;
